import Vue from 'vue';
import Router from 'vue-router';
import Controlboard from './views/Controlboard.vue';
import Developerboard from './views/Developerboard.vue';
import ApproveRelease from './views/ApproveRelease.vue';
import Users from './views/Users.vue';
import Personas from './views/Personas.vue';
import Login from './views/Login.vue';
import Audit from './views/Audit.vue';
import Logs from './views/Logs.vue';
import ErrorView from './views/ErrorView.vue';
import Store from './store';

Vue.use(Router);

function requireAuth(to, from, next) {
  if (Store.getters.getIsAuthenticated) {
    if (to.meta && to.meta.Code) {
      if (Store.getters.IsValidCode(to.meta.Code)) next(); else next('/error/You do not have access on the view/code/401');
    } else next();
  } else next('/login?message=You are not authorized');
}

export default new Router({
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      redirect: {
        name: 'login',
      },
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
    },
    {
      path: '/error/:message/code/:errorcode?',
      name: 'error',
      props: true,
      component: ErrorView,
    },
    {
      path: '/controlboard',
      name: 'controlboard',
      component: Controlboard,
      meta: {
        Code: 'AH1AG1312',
        IsApp: true,
      },
      beforeEnter: requireAuth,
    },
    {
      path: '/developerboard/:agentId',
      name: 'developerboard',
      component: Developerboard,
      meta: {
        Code: 'AH1DP1302',
        IsApp: true,
      },
      beforeEnter: requireAuth,
    },
    {
      path: '/approverelease',
      name: 'approverelease',
      component: ApproveRelease,
      meta: {
        Code: 'AH1AR1110',
        IsApp: true,
      },
      beforeEnter: requireAuth,
    },
    {
      path: '/logs',
      name: 'logs',
      component: Logs,
      meta: {
        Code: 'AH1LG1101',
        IsApp: true,
      },
      beforeEnter: requireAuth,
    },
    {
      path: '/users',
      name: 'users',
      component: Users,
      meta: {
        Code: 'AH1US0901',
        IsApp: false,
      },
      beforeEnter: requireAuth,
    },
    {
      path: '/personas',
      name: 'personas',
      component: Personas,
      meta: {
        Code: 'AH1PR0106',
        IsApp: false,
      },
      beforeEnter: requireAuth,
    },
    {
      path: '/audit',
      name: 'audit',
      component: Audit,
      meta: {
        Code: 'AH1AU0013',
        IsApp: false,
      },
      beforeEnter: requireAuth,
    },
  ],
});
